module.exports = __webpack_public_path__ + "img/client_registry_mirogrup.1d847f5d.png";